import { Theme } from '@mui/material/styles';
import { DealActivityEventPriority } from '@trnsact/trnsact-shared-types';

export const PRIORITY_CONFIG: Record<DealActivityEventPriority, { label: string; color: (theme: Theme) => string }> = {
  [DealActivityEventPriority.High]: { label: 'High', color: theme => theme.palette.error.main },
  [DealActivityEventPriority.Medium]: { label: 'Medium', color: theme => theme.palette.warning.main },
  [DealActivityEventPriority.Low]: { label: 'Low', color: theme => theme.palette.success.main },
};
